import apiClient from '../axios.js';

/**
 * 客戶員工帳號管理 API
 */
export const staffAccountService = {
  /**
   * 取得員工帳號列表
   * @param {Object} params - 查詢參數
   * @returns {Promise<Object>} 員工帳號列表
   */
  getAccounts: async (params = {}) => {
    const response = await apiClient.get('/client/staff/accounts', { params });
    return response;
  },

  /**
   * 取得單一員工帳號詳情
   * @param {string} id - 帳號 ID
   * @returns {Promise<Object>} 帳號詳情
   */
  getAccount: async (id) => {
    const response = await apiClient.get(`/client/staff/accounts/${id}`);
    return response;
  },

  /**
   * 新增員工帳號
   * @param {Object} accountData - 帳號資料
   * @returns {Promise<Object>} 新增結果
   */
  createAccount: async (accountData) => {
    const response = await apiClient.post('/client/staff/accounts', accountData);
    return response;
  },

  /**
   * 更新員工帳號
   * @param {string} id - 帳號 ID
   * @param {Object} accountData - 帳號資料
   * @returns {Promise<Object>} 更新結果
   */
  updateAccount: async (id, accountData) => {
    const response = await apiClient.put(`/client/staff/accounts/${id}`, accountData);
    return response;
  },

  /**
   * 刪除員工帳號
   * @param {string} id - 帳號 ID
   * @returns {Promise<Object>} 刪除結果
   */
  deleteAccount: async (id) => {
    const response = await apiClient.delete(`/client/staff/accounts/${id}`);
    return response;
  },
};
